// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__JYSU0","checkbox_active":"Checkbox_checkbox_active__cRz9m"};